/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Purchasable,
  PurchasableOptional,
  PurchasableMetaI,
  PurchasableTrackedI,
} from "./purchasable";
import { PurchasableTracked, PurchasableMeta } from "./purchasable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface GuestPrivsBase
 */
export interface GuestPrivsBaseOptional extends PurchasableOptional {
  /**
   *
   * @type {number}
   * @memberof GuestPrivsBase
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof GuestPrivsBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof GuestPrivsBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof GuestPrivsBase
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof GuestPrivsBase
   */
  startDate?: Date;
}

export interface GuestPrivsBase extends GuestPrivsBaseOptional, Purchasable {
  /**
   *
   * @type {number}
   * @memberof GuestPrivsBase
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof GuestPrivsBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof GuestPrivsBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof GuestPrivsBase
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof GuestPrivsBase
   */
  startDate?: Date;
}

export interface GuestPrivsBaseTrackedI extends PurchasableOptional {
  /**
   *
   * @type {number}
   * @memberof GuestPrivsBase
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof GuestPrivsBase
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof GuestPrivsBase
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof GuestPrivsBase
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof GuestPrivsBase
   */
  startDate?: Date;
  startDateIsSet: boolean;
}

transformDatesMap.set("GuestPrivsBase", function (model: GuestPrivsBase) {
  if (typeof model.purchaseDate == "string")
    model.purchaseDate = new Date(model.purchaseDate);
  if (typeof model.startDate == "string")
    model.startDate = new Date(model.startDate);
});

export type GuestPrivsBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startDate: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var GuestPrivsBaseMeta: GuestPrivsBaseMetaI = {} as GuestPrivsBaseMetaI;
GuestPrivsBaseMeta = typeMeta("GuestPrivsBase", {
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.Date),
});

const metaI = GuestPrivsBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PurchasableMeta]);
  metaI.price.inheritedFrom = PurchasableMeta.price;
  metaI.purchasableState.inheritedFrom = PurchasableMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = PurchasableMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = PurchasableMeta.voidCloseId;
});

export class GuestPrivsBaseTracked
  extends PurchasableTracked
  implements GuestPrivsBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  startDate__I?: Date = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | Date) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  constructor(config?: GuestPrivsBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: GuestPrivsBaseOptional,
    options?: AssignOptions,
  ): GuestPrivsBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): GuestPrivsBaseTrackedI {
    const cloned = {} as GuestPrivsBaseTrackedI;
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): GuestPrivsBaseTrackedI {
    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    return this;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuestPrivsBaseMeta.price,
      GuestPrivsBaseMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuestPrivsBaseMeta.purchasableState,
      GuestPrivsBaseMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuestPrivsBaseMeta.purchaseDate,
      GuestPrivsBaseMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuestPrivsBaseMeta.voidCloseId,
      GuestPrivsBaseMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuestPrivsBaseMeta.startDate,
      GuestPrivsBaseMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
